/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { CMS_API_BASE } from "../../helper/constants";
import { getDrupalImageUrl } from "../../api/about/aboutapi";

interface Props {
  data: any;
}

const WhyChooseSectionn: React.FC<Props> = ({ data}) => {
   const node = data.data;
        
           /** Collect included images */
          const included = data?.included || [];
        
           // 📌 Featured image URL
          const featuredId = node?.relationships?.field_featured_image?.data?.id;
          const featuredUrl = getDrupalImageUrl(featuredId, included);
        
           // 📌 Gallery Images
           const galleryIds = node?.relationships?.field_gallery_images?.data || [];
           const galleryImages = galleryIds.map((img:any) => {
            const media = included.find((inc:any) => inc.id === img.id);
            const file = included.find(
              (inc:any) => inc.id === media?.relationships?.field_media_image?.data.id
            );
    
            return file?.attributes?.uri?.url || "";
          });
          //  const galleryUrls = galleryIds
          //    .map((g: any) => getDrupalImageUrl(g.id, included))
          //    .filter(Boolean);
         
            const titles = node.attributes.field_title;            // array
           
            const subtitles = node.attributes.field_sub_title; // array
      const finalArray1 = subtitles.map((title:any, index:any) => ({
              title,
              image: CMS_API_BASE+galleryImages[index]
            }));
            const finalArray2 = titles.map((title:any, index:any) => ({
              title,
              subtitle: subtitles[index],
            
              image: CMS_API_BASE+galleryImages[index + 3]
            }));
           
  return (
   
    <div id="whychoosegro" className="container pt-4">
      <section className="whychoosegro section">
        <div className="row">
          <div className="col-sm-7" data-aos="fade-up" data-aos-delay="100">
            <div className="section-title" data-aos="">
              <h2>{node?.attributes?.field_description || ""}</h2>
            </div>
            
            <div className="container" data-aos="fade-up" data-aos-delay="100">
              <div className="row gx-2">
                <div className="col-sm-12 text-start">
                  <p 
                    className="pe-md-5" 
                    dangerouslySetInnerHTML={{ 
                      __html: node?.attributes?.field_content?.value || '' 
                    }} 
                  /> 
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-sm-4" data-aos="slide-left" data-aos-delay="100">
            <img 
              loading="lazy" 
              src={featuredUrl ||  " "} // aboutImg16
              className="img-fluid px-3"  
              data-aos="zoom-out"
              alt="Why Choose Gro"
            />
          </div>
          
          <div className="col-sm-12 keyfeatures" data-aos="fade-up" data-aos-delay="100">
            <h6>{node?.attributes?.field_sub_description}</h6>
            <div className="row gx-2">
              {finalArray1?.map((d:any,i:any) => (
                <div key={i} className="col-lg-2 col-md-4 col-sm-6 text-center">
                   <div className="img-holder" data-aos="zoom-in" data-aos-delay="100">
                 
                  <img  loading="lazy"  src={d.image}  className="img-fluid"  />
                  </div>
                  <p>{d.title}</p>
                </div>
              ))}

              {finalArray2?.map((d:any,i:any) => (
                <div key={`extra-${i}`} className="col-lg-2 col-md-4 col-sm-6 text-center">
                   <div className="img-holder" data-aos="zoom-in" data-aos-delay="100">
                  <img loading="lazy"  src={d.image}  className="img-fluid"  />
                  </div>
                  <p>{d.title}</p>
                </div>
              ))}
              
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyChooseSectionn;